<template>
    <div>

        <vue-headful title="Training Courses :: MeritEHS"/>

        <h4 class="py-2 mb-3">
            <ol class="breadcrumb font-weight-bold m-0 d-block d-md-inline-block">
                <li class="breadcrumb-item font-weight-light d-block d-md-inline-block">
                    <router-link :to="`/training-courses`">
                        <i class="fa fa-graduation-cap"></i> Training Courses
                    </router-link>
                </li>
                <li class="breadcrumb-item active d-block d-md-inline-block mt-md-0 mt-2">Expiring Course Alerts</li>
                <li class="ml-3 d-sm-inline-block d-none" v-if="this.$root.hasPermission(['training_courses.manage'])">
                    <router-link :to="`/training-courses/alerts/create`" class="btn btn-sm btn-success"><i class="fa fa-plus"></i> New</router-link>
                </li>
            </ol>
        </h4>

        <div class="d-sm-none d-block mb-3" v-if="this.$root.hasPermission(['training_courses.manage'])">
            <router-link :to="`/training-courses/alerts/create`" class="btn btn-sm btn-success"><i class="fa fa-plus"></i> New</router-link>
        </div>

        <div class="card mt-1">
            <div class="card-body">
                <v-client-table ref="emailRulesTable" :columns="columns" :options="options" :data="alerts">
                    <template slot="id" slot-scope="props">
                        <router-link  :to="`/training-courses/alerts/edit/${props.row.id}`" title="Edit Email Alert" class="btn btn-sm btn-secondary">
                            <i class="fa fa-edit"></i> Edit
                        </router-link>
                        <router-link :to="`/training-courses/alerts/delete/${props.row.id}`" title="Delete Email Alert" class="btn btn-sm btn-danger">
                            <i class="fa fa-trash"></i> Delete
                        </router-link>
                    </template>

                    <router-link slot="alert_name" slot-scope="props" :to="`/training-courses/alerts/view/${props.row.id}`" title="View Email Alert">
                        {{ props.row.alert_name }}
                    </router-link>

                    <template slot="is_active" slot-scope="props">
                        <label v-if="props.row.is_active == 1" class="badge badge-success">Active</label>
                        <label v-if="props.row.is_active == 0" class="badge badge-warning">Inactive</label>
                    </template>

                    <template slot="child_row" slot-scope="props">
                        <div class="row" style="margin-right: -0.625rem; margin-left: -0.625rem;">
                            <div class="col-md-4 col-12 mb-md-0 mb-3">
                                <span class="font-weight-bold">Description:</span><br>
                                <div v-html="props.row.description"></div>
                            </div>
                            <div class="col-md-4 col-12 mb-md-0 mb-3">
                                <span class="font-weight-bold">Recipients:</span><br>
                                <ol>
                                    <li v-for="(recip, key) in props.row.recipients">
                                        {{ recip.target_type }} -
                                        <template v-if="recip.target_type == 'Employee' || recip.target_type == 'User'">
                                            {{ recip.target_label.FirstName }} {{ recip.target_label.LastName }}
                                        </template>
                                        <template v-else>{{ recip.target_label }}</template>
                                    </li>
                                </ol>
                            </div>
                            <div class="col-md-4 col-12 mb-md-0 mb-3">
                                <span class="font-weight-bold">Only Send for Courses:</span><br>
                                <ol>
                                    <li v-for="(course, key) in props.row.filter_on_courses">
                                        {{ course.course_name }}
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </template>
                </v-client-table>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                alerts: [],
                columns: ['id', 'alert_name', 'days_until_expires', 'is_active'],
                options: {
                    columnsDropdown: false,
                    headings: {
                        id: 'Actions',
                        alert_name: 'Name',
                        days_until_expires: 'Days Until Expires',
                        is_active: 'Status',
                    },
                    orderBy: {
                        ascending: false,
                        column: 'inc_alerts.id',
                    },
                }
            }
        },

        methods: {
            //Load the Account
            getAlerts(){
                //Send it
                this.$http.get('training-courses/alerts')
                    .then(res => {
                        //Set data
                        this.alerts = res.data.alerts;
                    })
                    .catch(err => {

                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },
        },

        mounted(){
            this.getAlerts();
        },
    }
</script>
